import type { ChatRole } from '../../../store/slices/chat/types';
import { parseChatMessage } from '../../../utils/chat';
import { Fetcher } from '../../Fetcher';

import type { ITableLevelMessagesResponse, TableMessage } from './types';

export interface FetchTableLevelMessagesParams {
  casinoId: string;
  language: string;
  offset: number;
  recordsPerPage: number;
  showOtherMessages: boolean;
  tableId: string;
  tagMessage: ChatRole;
  url: string;
  userId: string | null;
}

export const fetchTableLevelMessages = ({
  casinoId,
  language,
  offset,
  recordsPerPage,
  showOtherMessages,
  tableId,
  tagMessage,
  url,
  userId,
}: FetchTableLevelMessagesParams): Promise<TableMessage[]> => {
  return Fetcher.fetch<ITableLevelMessagesResponse>(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: {
      casinoId,
      lang: language,
      offset,
      recordsPerPage,
      showOtherMessages,
      tableId,
      tagMessage,
      userId,
    },
  }).then((response) => response.list.map((message) => parseChatMessage(message)));
};
